/**
 * water-mark - 用于增加水印
 */
let textName = 'helloBike';
//
const size = 14;
const rotate = (target, text = 'test', width, height) => {
  const context = target.getContext('2d');
  const metrics = context.measureText(text);

  context.globalAlpha = 0.4;
  context.fillStyle = '#ccc';
  context.font = `${size}px Josefin Slab`;
  context.rotate((-25 * Math.PI) / 180);

  const rows = Math.ceil(height / size);
  const cols = Math.ceil(width / metrics.width);

  for (let i = 0; i < rows; i += 1) {
    for (let j = 0; j < cols * 2; j += 1) {
      context.fillText(
        text,
        (metrics.width * 4 * j) - (100 * i),
        size * i * 4,
      );
    }
  }
  return target;
};
/**
   * 获取水印图片的url
   *
   * @param text - 水印文本
   * @param width - 水印总宽度
   * @param height - 水印总高度
   * @returns {string}
   */
function getWaterMarkMaskUrl(text, width, height) {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  const image = ctx.getImageData(0, 0, width, height);
  const imageData = image.data;
  const { length } = imageData;
  for (let i = 3; i < length; i += 4) {
    imageData[i] = 0;
  }
  ctx.putImageData(image, 0, 0);
  rotate(canvas, text, width, height);
  return canvas.toDataURL();
}
// set node style
function setNodeStyle(node, text) {
  node.style.position = 'absolute';
  node.style.top = 0;
  node.style.left = 0;
  node.style.width = '100%';
  node.style.height = '100%';
  node.style['z-index'] = 1;
  node.style['pointer-events'] = 'none';
  //
  if (!window[`waterMarkDataUrl${text}`]) {
    window[`waterMarkDataUrl${text}`] =
      getWaterMarkMaskUrl(text, window.innerWidth * 1.4, window.innerHeight);
  }
  //
  node.style['background-image'] = `url("${window[`waterMarkDataUrl${text}`]}")`;
}

export default {
  name: 'watermark',
  setTextName(text) {
    textName = text;
  },
  inserted(el, binding) {
    const node = document.createElement('div');
    //
    let elTemp = el;
    //
    function setNodeEl(value) {
      if (value === 'none') { // target.parentNode
        node.style.display = 'none';
      } else if (value === 'after') {
        elTemp = el.parentNode;
      }
    }
    //
    if (typeof binding.value === 'object') {
      setNodeEl(binding.value.type);
      if (binding.value.text) {
        binding.textName = binding.value.text;
      } else {
        binding.textName = textName;
      }
    } else {
      setNodeEl(binding.value);
      binding.textName = textName;
    }
    //
    setNodeStyle(node, binding.textName);
    //
    const needRelative = position =>
      ['relative', 'absolute', 'sticky', 'fixed'].indexOf(position) < 0;

    if (needRelative(elTemp.style.position)) {
      elTemp.style.position = 'relative';
    }
    elTemp.appendChild(node);
    el.waterNode = node;
  },
  update(el, binding) {
    let { value } = binding;
    if (typeof binding.value === 'object') {
      value = binding.value.type;
    }
    if (value && value === 'NONE') {
      el.waterNode.style.display = 'none';
    } else {
      el.waterNode.style.display = 'block';
    }
  }
};



// WEBPACK FOOTER //
// ./src/directives/watermark.js